<template>
    <main id="mainCtrl">
        <LimitedDialog ref="dialog" :tariff-prices="tariffPrices"/>
        <div class="promo">
            <div class="promo__data">
                <div class="promo__title">Нужны пациенты бесплатно?</div>
                <div class="promo__markers">
                    <div class="promo__marker promo__marker_red">
                        Скидка 50%
                    </div>
                    <div class="promo__marker promo__marker_green">
                        При оплате на 12 месяцев
                    </div>
                </div>
                <div class="promo__text">
                    <p>
                        Подключите полный доступ в личный кабинет, чтобы включить запись на прием и получать пациентов.
                    </p>
                    <ul>
                        <li>Включите онлайн-запись на прием</li>
                        <li>Включите запись на прием по телефону</li>
                        <li>Настройте выгрузку врачей в Яндекс</li>
                        <li>Подключите мессенджеры и соцсети</li>
                        <li>Получайте пациентов бесплатно</li>
                        <li>Управляйте данными клиники</li>
                        <li>Загружайте цены на услуги</li>
                        <li>Публикуйте акции и новости</li>
                        <li>Добавьте кнопку действия</li>
                        <li>Анализируйте статистику</li>
                        <li>Отвечайте на отзывы пациентов</li>
                    </ul>
                </div>
                <div class="promo__actions">
                    <a
                        href="#" class="promo__btn"
                        @click="openDialog">Попробовать</a>

                    <div class="promo__akcent-label">от {{formatPrice(tariffPrices.vigodnijPriceMonth)}} рублей в месяц</div>
                </div>
            </div>
            <div class="promo__img">
                <img src="/img/lustra.svg" alt="" />
            </div>
        </div>
    </main>
</template>

<script>
import LimitedDialog from "@dialogs/limited/Clinic";
import { formatPrice } from "@/global/helpers";

export default {
    components: {
        LimitedDialog
    },
    props:{
        tariffPrices: {
            type: Object,
            required: true
        }
    },
    data(){
        return{
            formatPrice:formatPrice
        }
    },
    methods: {
        openDialog() {
            const yaCounter = window['yaCounter97357971'];
            if (yaCounter !== undefined) {
                yaCounter.reachGoal('LK_TARIFS_BTN');
            }
            this.$refs.dialog.show();
        }
    },
}
</script>
